// ==================================================
//  전역 변수
// ==================================================

const globalVar = {
    // CSRF Token
    csrfToken: undefined,
    // 계정 - 검색 바 - 필터
    filterName: undefined,
}

export default globalVar;
